module.exports = __webpack_public_path__ + "img/img7.4f9cf3bc.svg";